import { useEffect } from 'react';
import { Helmet } from 'react-helmet';

import { useBusinessToolStore } from 'store/useBusinessToolStore';
import { getBusinessToolStoreClear } from 'store/useBusinessToolStore/selectors';

import { useAuthenticated } from 'hooks/useAuthenticated';

import { ErrorBoundaryFallbackComponent } from 'components/ErrorBoundaryFallback/ErrorBoundaryFallbackComponent';

export const ErrorPage = () => {
  const { isAuthenticated, isAuthConfiguring } = useAuthenticated();
  const clearBusinessToolStore = useBusinessToolStore(getBusinessToolStoreClear);

  useEffect(() => {
    clearBusinessToolStore();
  }, []);

  return (
    <>
      <Helmet>
        <script type="text/javascript" defer>
          {`
            window.dataLayer = window.dataLayer || [];
            let userId = '';
            try {
              const userStore = localStorage.getItem('user-store');
              if (userStore) {
                const parsed = JSON.parse(userStore);
                userId = parsed?.state?.authUser?.id || '';
                dataLayer.push({ user_id: userId });
              }
            } catch (e) {
              console.error('Failed to parse user-store:', e);
            }
          `}
        </script>
      </Helmet>
      <ErrorBoundaryFallbackComponent authenticated={isAuthenticated || isAuthConfiguring} />
    </>
  );
};
